import React, { useState } from "react";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Form } from "react-bootstrap";
import EmployeeService from "../../services/employee.services";

import New_User_Sample from "../../assets/sample/New-User.csv";

const UploadEmployee = ({ uploadModal, setUploadModal, fetchHolidayList }) => {
  const [validated, setValidated] = useState(false);

  const [uploaded, setUploaded] = useState(false);

  const [bulkCsvFile, setBulkCsvFile] = useState("");

  const handleFileChange = (e) => {
    setBulkCsvFile(e.target.files[0]);
    setUploaded(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", bulkCsvFile);

    EmployeeService.uploadEmployee(formData)
      .then((resp) => {
        if (resp.data.errors) {
          toast.warn("Holiday not Added", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          fetchHolidayList();
          toast.success("Holidays Added Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div
        className={`${
          uploadModal
            ? "add-event feedback policy visible"
            : "add-event feedback policy hidden"
        }`}
      >
        <div className="flex mb-5">
          <div className="left-flex mb-4">
            <span>Bulk Upload Users </span>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="event-form scroll">
              <div className="sample-file">
                <a href={New_User_Sample} download={`New_User_Sample_${new Date(Date.now()).toLocaleDateString('en-GB')}.csv`}>Sample file for bulk upload</a>
              </div>
              <div className="bulk-upload mb-4">
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.5535 2.49392C12.4114 2.33852 12.2106 2.25 12 2.25C11.7894 2.25 11.5886 2.33852 11.4465 2.49392L7.44649 6.86892C7.16699 7.17462 7.18823 7.64902 7.49393 7.92852C7.79964 8.20802 8.27403 8.18678 8.55353 7.88108L11.25 4.9318V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V4.9318L15.4465 7.88108C15.726 8.18678 16.2004 8.20802 16.5061 7.92852C16.8118 7.64902 16.833 7.17462 16.5535 6.86892L12.5535 2.49392Z"
                      fill="#4E465E"
                    />
                    <path
                      d="M3.75 15C3.75 14.5858 3.41422 14.25 3 14.25C2.58579 14.25 2.25 14.5858 2.25 15V15.0549C2.24998 16.4225 2.24996 17.5248 2.36652 18.3918C2.48754 19.2919 2.74643 20.0497 3.34835 20.6516C3.95027 21.2536 4.70814 21.5125 5.60825 21.6335C6.47522 21.75 7.57754 21.75 8.94513 21.75H15.0549C16.4225 21.75 17.5248 21.75 18.3918 21.6335C19.2919 21.5125 20.0497 21.2536 20.6517 20.6516C21.2536 20.0497 21.5125 19.2919 21.6335 18.3918C21.75 17.5248 21.75 16.4225 21.75 15.0549V15C21.75 14.5858 21.4142 14.25 21 14.25C20.5858 14.25 20.25 14.5858 20.25 15C20.25 16.4354 20.2484 17.4365 20.1469 18.1919C20.0482 18.9257 19.8678 19.3142 19.591 19.591C19.3142 19.8678 18.9257 20.0482 18.1919 20.1469C17.4365 20.2484 16.4354 20.25 15 20.25H9C7.56459 20.25 6.56347 20.2484 5.80812 20.1469C5.07435 20.0482 4.68577 19.8678 4.40901 19.591C4.13225 19.3142 3.9518 18.9257 3.85315 18.1919C3.75159 17.4365 3.75 16.4354 3.75 15Z"
                      fill="#4E465E"
                    />
                  </svg>
                </span>
                {uploaded ? (
                  <>
                    <span>{bulkCsvFile.name}</span>
                  </>
                ) : (
                  <>
                    <span>Bulk Upload CSV</span>
                  </>
                )}
                <input
                  type="file"
                  name="bulkCsvFile"
                  onChange={handleFileChange}
                  required
                />
              </div>
            </div>

            <div className="sort-action">
              <button
                className="btn btn-reset"
                onClick={(e) => {
                  setUploadModal(false);
                }}
              >
                Reset
              </button>
              <button className="btn btn-apply">Upload</button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default UploadEmployee;
